import React, { useEffect, useState } from 'react';
import { Box, Chip, Dialog, DialogContent, ListItem, ListItemText, IconButton, CircularProgress, CloseOutlinedIcon, } from '@kareo/design-system';
import { ListItemSecondaryAction } from '@material-ui/core';
import kfetch from '@kareo/kfetch';
var CLICKED_ON_MESSAGES_NAV_LOCAL_STORAGE_KEY = 'tebra_clicked_on_messages_nav';
var PatientMessagesNavItem = function (_a) {
    var patientId = _a.patientId;
    // State to manage error state
    var _b = useState(false), hasErrorFetchingPatientInfo = _b[0], setHasErrorFetchingPatientInfo = _b[1];
    // State to manage iframe loaded state
    var _c = useState(false), iframeLoaded = _c[0], setIframeLoaded = _c[1];
    // State to store patient guid
    var _d = useState(''), patientGuid = _d[0], setPatientGuid = _d[1];
    // has user already clicked on nav
    var _e = useState(false), clickedOnNav = _e[0], setClickedOnNav = _e[1];
    // State to manage dialog visibility
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    // set the iframeLoaded state to true when recieved post message from iframe - used in the template onload of iframe
    var handleIframeLoadedEvent = function (event) {
        var data = event.data, origin = event.origin;
        if (origin === window.location.origin &&
            data === 'messageCenterConversationsLoaded') {
            setIframeLoaded(true);
        }
    };
    useEffect(function () {
        window.addEventListener('message', handleIframeLoadedEvent);
        if (localStorage.getItem(CLICKED_ON_MESSAGES_NAV_LOCAL_STORAGE_KEY)) {
            setClickedOnNav(true);
        }
        return function () {
            window.removeEventListener('message', handleIframeLoadedEvent);
        };
    }, []);
    /**
     * Track event in full story
     * @param {string} eventName
     */
    var trackEvent = function (eventName) {
        if (typeof window.FS !== 'undefined') {
            window.FS('trackEvent', {
                name: eventName,
                properties: {
                    patient_id: patientId,
                    patient_guid: patientGuid,
                },
            });
        }
    };
    // open dialog
    var openDialog = function () {
        trackEvent('ptn_MsgModalLoad');
        setOpen(true);
    };
    // close dialog
    var closeDialog = function () {
        trackEvent('ptn_MsgModalClose');
        setIframeLoaded(false);
        setOpen(false);
    };
    // click on nav item
    var clickOnNavItem = function () {
        trackEvent('ptn_MsgLinkClick');
        // fetch patient info
        if (!patientGuid) {
            kfetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/header")
                .then(function (_a) {
                var guid = _a.guid;
                setPatientGuid(guid);
            })
                .catch(function () {
                setHasErrorFetchingPatientInfo(true);
            });
        }
        localStorage.setItem(CLICKED_ON_MESSAGES_NAV_LOCAL_STORAGE_KEY, Date.now().toString());
        setClickedOnNav(true);
        openDialog();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { onClick: clickOnNavItem, component: "a" },
            React.createElement(ListItemText, { primary: "Messages" }),
            !clickedOnNav && (React.createElement(ListItemSecondaryAction, null,
                React.createElement(Chip, { label: "New", type: "active" })))),
        React.createElement(Dialog, { open: open, onClose: closeDialog, maxWidth: "lg" },
            React.createElement(Box, { position: "absolute", right: "10px", top: "10px" },
                React.createElement(IconButton, { size: "small", "aria-label": "Close", onClick: closeDialog },
                    React.createElement(CloseOutlinedIcon, { fontSize: "xsmall" }))),
            React.createElement(DialogContent, { style: {
                    minHeight: '400px',
                    width: '70vw',
                    maxWidth: '1280px',
                    padding: 0,
                } }, patientGuid ? (React.createElement(React.Fragment, null,
                iframeLoaded ? null : (React.createElement(CircularProgress, { thickness: 5, style: {
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        zIndex: 10,
                        color: 'var(--primary-color-dark)',
                    } })),
                React.createElement("iframe", { src: "/messages-ui/#/message-center/messages/guid/" + patientGuid, width: "100%", frameBorder: "0", title: "Patient Messages", style: {
                        display: iframeLoaded ? 'block' : 'none',
                        height: '75vh',
                        minHeight: '400px',
                    } }))) : (React.createElement(React.Fragment, null, hasErrorFetchingPatientInfo ? (React.createElement("p", null, "Error fetching patient information")) : (React.createElement(CircularProgress, { thickness: 5, style: {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    color: 'var(--primary-color-dark)',
                } }))))))));
};
export default PatientMessagesNavItem;
